import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { ORGANISATION_PLACEHOLDER } from '../http-token.interceptor';
import { OrganisationOnboardingModel } from '../models/onboarding/onboarding-model';
import { OnboardingOrganisationResponse } from '../models/onboarding/onboarding-organisation-response';
import { CreateOrganisationOnboardingQuestionsCommand } from '../models/onboarding/onboarding-questions-command';
import { AppNavigationService } from './app-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private orgOnboarding$: Observable<OrganisationOnboardingModel> | null;
  private orgOnboardingId: number | null;

  organisationOnboarding: BehaviorSubject<OrganisationOnboardingModel> = new BehaviorSubject(
    {} as OrganisationOnboardingModel,
  );

  constructor(
    private appNavigationService: AppNavigationService,
    private http: HttpClient,
  ) {
    this.appNavigationService.onOrganisationChanged.subscribe(() => {
      this.resetOrganisation();
    });
  }

  createOrganisationOnboardingQuestions(command: CreateOrganisationOnboardingQuestionsCommand) {
    return this.http.post(`${environment.servicesApiUrl}/api/v3/onboarding`, command);
  }

  /**
   * Gets the organisation onboarding in state, or else makes API request
   *
   * @param organisationId specify the organisation
   */
  getOnboarding(organisationId?: number): Observable<OrganisationOnboardingModel> {
    if (!this.orgOnboarding$ || (organisationId && this.orgOnboardingId !== organisationId)) {
      this.orgOnboarding$ = this.getOrganisationOnboarding({ organisationId }).pipe(
        tap({
          error: () => {
            this.orgOnboarding$ = null;
          },
        }),
        map(response => {
          this.organisationOnboarding.next(response.organisationOnboarding);
          return response.organisationOnboarding;
        }),
        shareReplay(1),
      );
    }

    if (organisationId) {
      this.orgOnboardingId = organisationId;
    }
    return this.orgOnboarding$;
  }

  /**
   * Clear the onboarding organsiation in state
   */
  resetOrganisation() {
    this.orgOnboarding$ = null;
    this.orgOnboardingId = null;
  }

  private getOrganisationOnboarding({
    organisationId,
  }: {
    organisationId?: number;
  } = {}): Observable<OnboardingOrganisationResponse> {
    return this.http.get<OnboardingOrganisationResponse>(
      `${environment.servicesApiUrl}/api/v3/onboarding/${
        organisationId || ORGANISATION_PLACEHOLDER
      }`,
    );
  }
}
